// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"9971a7c8","503":"121b81bc","676":"3f6b69a1"}[chunkId] + ".chunk.js";
};